import { ColumnDescription } from "react-bootstrap-table-next";
import SpinnerComponent from "../../../../../Components/Loding/Spinner";
import Modulos from "../../../../../Components/Modulos";
import Table from "../../../../../Components/Table";
import { UsuarioInterface } from "../../../../../Interfaces/Geral/GestaoUsuarios/UsuariosInterface";

import "./styles.css";

interface AcessosPropsInterface {
    access: UsuarioInterface;
}

export default function Acessos(props: AcessosPropsInterface) {
    const {
        FUNCOES: lstFuncoesVinculadas,
        TELAS: lstTelasVinculadas,
        MODULOS: lstModulosVinculados,
    } = props.access;

    //Tabela
    const TableFormat = (cell: string) => {
        return (
            <span className="label label-lg font-weight-bold  label-light-primary label-inline h-auto m-2">
                {cell}
            </span>
        );
    };
    const TelaColumns: Array<ColumnDescription> = [
        {
            dataField: "DS_NOME_TELA",
            text: "Ordenar",
            formatter: TableFormat,
            style: { border: "none" },
            sort: true,
        },
    ];
    const FuncaoColumns: Array<ColumnDescription> = [
        {
            dataField: "DS_FUNCAO",
            text: "Ordenar",
            style: { border: "none" },
            formatter: TableFormat,
            sort: true,
        },
    ];

    return lstTelasVinculadas &&
        lstFuncoesVinculadas &&
        lstModulosVinculados ? (
        <div className="row">
            <div className="col-12">
                <div className="align-items-center flex-row">
                    <h3 className="mb-3 text-center">Funções</h3>
                    {lstFuncoesVinculadas ? (
                        lstFuncoesVinculadas.length > 0 ? (
                            <Table
                                columns={FuncaoColumns}
                                data={lstFuncoesVinculadas}
                                keyField="ID_FUNCAO"
                                bodyClasses="d-flex flex-wrap border-0 pt-2"
                                classes="border-0"
                                headerClasses="border-0 border-bottom"
                                noHover
                            />
                        ) : (
                            <div className="text-black-50 text-center">
                                Esse usuário não tem acesso a nenhuma função
                            </div>
                        )
                    ) : (
                        <span>loading</span>
                    )}
                </div>
            </div>
            <div className="col-12">
                <br />
                <div className="align-items-center flex-row">
                    <h3 className="mb-3 text-center">Telas</h3>
                    {lstTelasVinculadas ? (
                        lstTelasVinculadas.length > 0 ? (
                            <Table
                                columns={TelaColumns}
                                data={lstTelasVinculadas}
                                keyField="ID_TELA"
                                bodyClasses="d-flex flex-wrap border-0 pt-2"
                                classes="border-0"
                                headerClasses="border-0 border-bottom"
                                noHover
                            />
                        ) : (
                            <div className="text-black-50 text-center">
                                Esse usuário não tem acesso a nenhuma tela
                            </div>
                        )
                    ) : (
                        <span>loading</span>
                    )}
                </div>
            </div>
            <div className="col-12 mt-5">
                <div className="RowCol1 align-items-center flex-row">
                    <h3 className="text-center">Módulos</h3>
                    {lstModulosVinculados ? (
                        lstModulosVinculados.length > 0 ? (
                            <>
                                <hr />
                                <div className="modulos d-flex flex-wrap justify-content-center">
                                    {lstModulosVinculados.map((modulo) => {
                                        return (
                                            <span
                                                key={modulo.ID_MODULO}
                                                className="moduloSpan d-flex flex-column align-items-center justify-content-center"
                                            >
                                                {Modulos(modulo.ID_MODULO)}
                                                <span className="">
                                                    {modulo.DS_MODULO}
                                                </span>
                                            </span>
                                        );
                                    })}
                                </div>
                            </>
                        ) : (
                            <div className="text-black-50 text-center">
                                Esse usuário não tem acesso a nenhum módulo
                            </div>
                        )
                    ) : (
                        <span>loading</span>
                    )}
                </div>
            </div>
        </div>
    ) : (
        <SpinnerComponent />
    );
}
